import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Button, Col, Form, Row, Spinner } from "react-bootstrap";
import BootTextField from "components/common/custom/forms/BootTextField";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { LoginUser } from "../config/AuthApi";
import TextInput from "components/common/custom/forms/BootTextField/TextField";
import { toast } from "react-toastify";
import { GetAllBranches } from "components/config/HeaderApi";
import { handleSelectedBU } from "components/config/HeaderSlice";
import { GetAllPermissionType } from "../../../features/user-permission/config/UserPermissionApi";

const LoginForm = () => {
  const dispatch = useDispatch();
  const { status, error } = useSelector((state) => state.auth);
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const [loading, setLoading] = useState(false);
  const getToken = localStorage.getItem("bearerToken");

  const navigate = useNavigate();
  useEffect(() => {
    if (getToken) {
      navigate("/", { replace: true });
    }
  }, [getToken]);

  const onSubmit = async (data) => {
    setLoading(true);
    const response = await dispatch(LoginUser(data)).unwrap();
    if (response?.success) {
      reset();
      toast.success(response?.message_en);
      await dispatch(GetAllPermissionType(response?.data?.employee?.syspri_id));

      const branchResponse = await dispatch(GetAllBranches()).unwrap();
      if (branchResponse?.success) {
        localStorage.removeItem("selectedBranch");
        dispatch(
          handleSelectedBU({
            check: "search",
            value: branchResponse?.data?.branch_sel_data?.find(
              (item) =>
                item?.branch_id ===
                response?.data?.employee?.branch_default?.branch_id
            ),
          })
        );
        localStorage.setItem(
          "selectedBranch",
          JSON.stringify(
            branchResponse?.data?.branch_sel_data?.find(
              (item) =>
                item?.branch_id ===
                response?.data?.employee?.branch_default?.branch_id
            )
          )
        );
      }
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <Form.Group className="mb-3">
        <TextInput
          name="email"
          control={control}
          label="Email address"
          type="email"
          placeholder="Email address"
          errors={errors}
          size="md"
          rules={{
            required: "Email is required",
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: "Invalid email address",
            },
          }}
        />
        {errors?.email && (
          <Form.Control.Feedback type="invalid">
            {errors?.email?.message}
          </Form.Control.Feedback>
        )}
      </Form.Group>

      <Form.Group className="mb-3">
        <TextInput
          name="password"
          control={control}
          label="Password"
          size="md"
          type="password"
          errors={errors}
          placeholder="Password"
          rules={{
            required: "Password is required",
            minLength: {
              value: 8,
              message: "Password must be at least 8 characters long",
            },
          }}
        />
        {errors?.email && (
          <Form.Control.Feedback type="invalid">
            {errors?.email?.message}
          </Form.Control.Feedback>
        )}
      </Form.Group>

      <Row className="justify-content-between mb-3">
        <Col style={{ textAlign: "right" }}>
          <Link to="/authentication/forgot-password">Forgot Password?</Link>
        </Col>
      </Row>

      <Button
        variant="primary"
        type="submit"
        className="w-100"
        disabled={loading}
      >
        {loading ? <Spinner size={"sm"} animation="border" /> : "Login"}
      </Button>
    </Form>
  );
};

export default LoginForm;
